module.exports = __webpack_public_path__ + "img/oborud.74885c19.svg";